// extracted by mini-css-extract-plugin
module.exports = {"title":"title__2hZqv","form":"form__34SFM","textarea":"textarea__UZprO","modal":"modal__Q3WUi"};